import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var Tile = /*#__PURE__*/React.forwardRef(function Tile2(props, ref) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/jsx(Box, _objectSpread(_objectSpread({}, rest), {}, {
    borderRadius: 2,
    padding: 2,
    ref: ref,
    children: children
  }));
});
Tile.displayName = "Tile";

export { Tile };
